import { useEffect, useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { useTranslation } from "react-i18next";

const translateBackend = (t, data, fallbackKey) => {
  if (!data) return t("msg_server_or_network");
  if (data.message_key) return t(data.message_key, data.message_params || {});
  return t(fallbackKey);
};

const VerifyEmail = () => {
  const { t } = useTranslation();
  const { search } = useLocation();
  const navigate = useNavigate();

  const qp = new URLSearchParams(search);
  const token = qp.get("token") || "";
  const flowParam = (qp.get("flow") || "").toLowerCase();

  const [status, setStatus] = useState("verifying"); // verifying | ok | fail
  const [message, setMessage] = useState("");
  const [showLoginButton, setShowLoginButton] = useState(true);

  useEffect(() => {
    if (!token) {
      setStatus("fail");
      setMessage(t("verify_missing_token"));
      return;
    }

    let endpoint = "/api/email/verify";
    if (flowParam === "change_email") endpoint = "/api/verify_change_email";
    if (flowParam === "delete_account") endpoint = "/api/verify_delete_account";

    (async () => {
      try {
        const res = await axios.post(endpoint, { token });

        if (res.status === 200 && res.data?.status === "success") {
          setStatus("ok");

          // message success depuis backend (message_key)
          const defaultKey =
            flowParam === "change_email"
              ? "verify_change_email_success"
              : flowParam === "delete_account"
              ? "verify_delete_account_success"
              : "verify_register_success";

          setMessage(translateBackend(t, res.data, defaultKey));

          setShowLoginButton(flowParam !== "delete_account");
        } else {
          setStatus("fail");
          setMessage(translateBackend(t, res.data, "verify_failed"));
        }
      } catch (err) {
        setStatus("fail");
        setMessage(
          translateBackend(
            t,
            err?.response?.data,
            "verify_failed"
          )
        );
      }
    })();
  }, [token, flowParam, t]);

  if (status === "verifying") {
    return (
      <div className="container--sm card card--panel text-center">
        <h2 className="title">{t("verify_verifying_title")}</h2>
        <p className="message message--info">{t("verify_verifying_text")}</p>
      </div>
    );
  }

  if (status === "ok") {
    return (
      <div className="container--sm card card--panel text-center">
        <h2 className="title">✅ {t("verify_success_title")}</h2>
        <p className="message message--success">{message}</p>

        {showLoginButton && (
          <button className="btn btn-lg mt-10" onClick={() => navigate("/login")}>
            {t("verify_go_login")}
          </button>
        )}
      </div>
    );
  }

  return (
    <div className="container--sm card card--panel text-center">
      <h2 className="title">❌ {t("verify_fail_title")}</h2>
      <p className="message message--error">{message}</p>

      <Link to="/login" className="btn btn-ghost mt-10">
        {t("verify_back_login")}
      </Link>
    </div>
  );
};

export default VerifyEmail;
